






























































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Compra extends Vue {
  // private states: any = null;
  private precio = 899;
  private envio = 0;
  private discount = 0;
  private meses = 0;

  public calculateTotal() {
    return this.precio + this.envio - this.discount;
  }

  public nextStep(): void {
    this.$store.commit(
      'setShoppingCartStep',
      this.$store.getters.getShoppingCartStep + 1,
    );
  }

  public priorStep() {
    this.$store.commit(
      'setShoppingCartStep',
      this.$store.getters.getShoppingCartStep - 1,
    );
  }

  public msi() {
    this.meses = this.calculateTotal() / 6;
    return this.meses.toFixed(2);
  }

  public currentStep() {
    return this.$store.getters.getShoppingCartStep;
  }
}
